// utils/copyToClipboard.js
export async function copyToClipboard(content) {
  try {
    if (content instanceof HTMLElement) {
      const html = content.outerHTML;
      const text = content.innerText;

      await navigator.clipboard.write([
        new ClipboardItem({
          "text/plain": new Blob([text], { type: "text/plain" }),
          "text/html": new Blob([html], { type: "text/html" }),
        }),
      ]);
    } else {
      await navigator.clipboard.writeText(content);
    }
    return true;
  } catch (err) {
    // Fallback for older browsers
    if (typeof content === "string") {
      const textarea = document.createElement("textarea");
      textarea.value = content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      return true;
    }
    return false;
  }
}
